module.exports = __webpack_public_path__ + "media/bootstrap-icons/easel-69b7057e.svg";